import React from 'react';
import PropTypes from 'prop-types';
import SliceErrorBoundary from '../../../components/SliceErrorBoundary';
import Adventurer from '../../../components/CreationForm/Adventurer';

import './CreationForm.scss';

const CreationFormWidget = props => {
  const slices = props.model.prismicPageModel.slices || [];
  const slice = slices.find(slice => slice.type === 'ProductForm');
  return (
    <main
      id="creation-form-widget"
      className="creation-form-widget"
      data-test="creation-form-widget"
      data-wio-id={props.model.prismicPageModel.metadata.id}>
      <SliceErrorBoundary>
        <Adventurer fetchPrismicProduct={props.fetchPrismicProduct} {...slice.primary.product} />
      </SliceErrorBoundary>
    </main>
  );
};

CreationFormWidget.propTypes = {
  model: PropTypes.object.isRequired,
  fetchPrismicProduct: PropTypes.func.isRequired,
};

export default CreationFormWidget;



// WEBPACK FOOTER //
// ./src/client/js/view/routes/Widgets/CreationForm/CreationForm.js